import { AssignmentRow } from './AssignmentGetResponse';

// 削除モーダルで扱うための空データ（Project の EmptyProjectDeleteItem 相当）
export const EmptyAssignmentDeleteItem: AssignmentRow = {
  id: 0,
  employeeCode: '',
  name: '',
};
